import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import style from "./workout.module.css"
import Imgs from "../image/images";


const Workout = () =>{
    var settings = {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
      }; 
    const navigate = useNavigate();
    return(
        <div style={{backgroundColor:"white"}}>
            <div className={style.head}>
                <h1 style={{color: 'white',textShadow: '0px 0px 20px black'}}>WorkOut</h1>
                <img src={Imgs.logo} alt="not_found" className={style.logo}/>
            </div>
            <div className={style.body}>
                <Slider {...settings}>
                    <div>
                        <div style={{height: '580px',width: '100%',borderRadius: '20px',position: 'relative',left: '3%'}}>
                            <img src="https://wallpapers.com/images/featured/chris-bumstead-1lnwxxn436advkdz.jpg" alt="not_found" style={{width: '1200px'}}/>
                            <p style={{position: 'absolute',color: 'whitesmoke',top: '44%',left: '20%'}}>Shape your body</p>
                            <h1 style={{position: 'absolute',top: '50%',left: '20%',color: 'whitesmoke'}}>BE</h1>
                            <h1 style={{position: 'absolute',top: '50%',left: '24%',color: '#F35F00'}}>STRONG</h1>
                            <h1 style={{position: 'absolute',top: '58%',left: '20%',color: 'whitesmoke'}}>TRAINING</h1>
                            <h1 style={{position: 'absolute',top: '58%',left: '32.5%',color: 'whitesmoke'}}>HARD</h1>
                            <div className={style.start}>
                                <a href="#gym" style={{textDecoration: 'none',color: 'white'}}>Get Start</a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={{height: '580px',display: 'flex',justifyContent: 'center',alignItems: 'center',borderRadius: '20px',position: 'relative'}}>
                            <img src="https://wallpapers.com/images/hd/bodybuilder-carrying-weight-hd-i76dec4842962y4b.jpg" alt="not_found" style={{width: '1200px'}}/>
                        </div>
                    </div>
                    <div>
                        <div style={{height: '580px',display: 'flex',justifyContent: 'center',alignItems: 'center',borderRadius: '20px'}}>
                            <img src="https://i.pinimg.com/originals/5e/2d/21/5e2d21a2df41e98e0f4d0b59b986b121.jpg" alt="not_found" style={{width: '1200px'}}/>
                        </div>
                    </div>
                    <div>
                        <div style={{height: '580px',display: 'flex',justifyContent: 'center',alignItems: 'center',borderRadius: '20px'}}>
                            <img src="https://c4.wallpaperflare.com/wallpaper/440/469/70/quote-motivational-arnold-schwarzenegger-wallpaper-thumb.jpg" alt="" style={{width: '1200px'}}/>
                        </div>
                    </div>
                </Slider>
            </div>
            <div className={style.gym} id="gym">
                <h1>BODYBUILDING</h1>
                <p>Choose Exercise of your choice</p>
                <div className={style.abs} onClick={()=>navigate("/Absworkout")}>
                    <p>Abs & Core</p>
                    <img src="https://i.pinimg.com/originals/e3/ff/bb/e3ffbb90235d56360c698e13c8c06762.jpg" alt="not_found" />
                </div>
                <div className={style.back} onClick={()=>navigate("/Backworkout")}>
                    <p>Back</p>
                    <img src="https://i.pinimg.com/736x/8d/85/b6/8d85b61410b5492c479f46ed1d9b5037.jpg" alt="not_found" />  

                </div>
                <div className={style.arms} onClick={()=>navigate("/Armsworkout")}>
                    <p>Arms</p>
                    <img src="https://i.pinimg.com/enabled_hi/564x/55/87/e3/5587e303932c3dc12288d346512384be.jpg" alt="not_found" />
                </div>
                <div className={style.legs} onClick={()=>navigate("/Legsworkout")}>
                    <p>Legs</p>
                    <img src="https://i.pinimg.com/236x/8c/af/90/8caf90c0529acf75110a2d3d5293f786.jpg" alt="" />
                </div>
                <div className={style.chest} onClick={()=>navigate("/Chestworkout")}>
                    <p>Chest</p>
                   <img src="https://i.pinimg.com/enabled_hi/564x/2a/44/a2/2a44a27fb2c92b35c25449149cf62906.jpg" alt="" />
                </div>
                <div className={style.shoulders} onClick={()=>navigate("/Shoulderworkout")}>
                    <p>Shoulders</p>
                    <img src="https://i.pinimg.com/736x/5b/79/25/5b79254a93fe2aa1dcdc65affded0647.jpg" alt="" />
                </div>
            </div>
        </div>
        
    )
}
export default Workout;